import { VS } from '../Components.js';
import PointType from '../PointType.js';
import Spell from '../Spell.js';

import AreaOfEffects from '../../Actions/AreaOfEffects.js';
import Durations from '../../Actions/Durations.js';
import Effects from '../../Actions/Effects.js';
import Ranges from '../../Actions/Ranges.js';
import Times from '../../Actions/Times.js';
import ToHits from '../../Actions/ToHits.js';
import Utilities from '../../Actions/Utilities.js';

export default new Spell(
  'Prestidigitation',
  0,
  PointType.SpellSlot,
  [
    'This spell is a minor magical trick that novice spellcasters use for practice. You create one of the following magical effects within range:',
    '* You create an instantaneous, harmless sensory effect, such as a shower of sparks, a puff of wind, faint musical notes, or an odd odor.',
    '* You instantaneously light or snuff out a candle, a torch, or a small campfire.',
    '* You instantaneously clean or soil an object no larger than 1 cubic foot.',
    '* You chill, warm, or flavor up to 1 cubic foot of nonliving material for 1 hour.',
    '* You make a color, a small mark, or a symbol appear on an object or a surface for 1 hour.',
    '* You create a nonmagical trinket or an illusory image that can fit in your hand and that lasts until the end of your next turn.',
    'If you cast this spell multiple times, you can have up to three of its non-instantaneous effects active at a time, and you can dismiss such an effect as an action.',
  ],
  Utilities.NonCombat,
  Times.Action,
  Durations.Hours(1),
  Ranges.Range(10),
  AreaOfEffects.SingleTarget,
  ToHits.AlwaysWorks,
  Effects.Utility(),
  VS,
  'Transmutation'
);
